/**
 * Authentication utility functions
 */

/**
 * Check if the current user is a platform admin
 * @param userType - The user_type from the customer data
 * @returns true if the user is an admin
 */
export function isAdminUser(userType?: string): boolean {
  return userType === 'admin';
}

/**
 * True when an admin is looking at another customer's data via a `customer_id` URL param.
 * A `customer_id` naming the signed-in account (by id or tag) is the user's own data.
 */
export function isOtherCustomer(
  customerParam: string | null | undefined,
  permissions?: { userType?: string; customerId?: string; customerTag?: string } | null,
): boolean {
  if (!customerParam || !isAdminUser(permissions?.userType)) return false;
  return customerParam !== permissions?.customerId && customerParam !== permissions?.customerTag;
}

/**
 * Check if the current user has a specific permission
 * @param permissions - Array of permissions
 * @param permission - The permission to check
 * @returns true if the user has the permission
 */
export function hasPermission(permissions: string[] | undefined, permission: string): boolean {
  return permissions?.includes(permission) || false;
}
